var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "hand-illustration-path-banner",
    points: "0.000740740741 0.00616326736 48.9938272 0.00616326736 48.9938272 48.9240163 0.000740740741 48.9240163"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "hand-illustration-path-3",
    points: "0.00347559384 0.00718282246 16.8578714 0.00718282246 16.8578714 29.7775214 0.00347559384 29.7775214"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-small-illustration",
    transform: "translate(-434.000000, -88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-Group-2",
    transform: "translate(431.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand_illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hand-illustration-hand_mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hand-illustration-path-banner"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-hand_Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4287654,20.4497211 C36.4287654,20.4497211 37.0824691,22.7805455 33.3512346,23.6925858 L22.7498765,26.2841165 C22.7498765,26.2841165 21.5867901,26.5684897 21.2638272,25.4170681 L20.9330864,24.2376652 C20.9330864,24.2376652 20.2793827,21.9068408 24.0106173,20.9946772 L33.4367901,18.6904781 C33.4367901,18.6904781 35.7751852,18.1187734 36.424321,20.4334501 L36.4287654,20.4497211",
    id: "Fill-34",
    fill: "#DDAB89",
    mask: "url(#hand-illustration-hand_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.834321,27.9072746 C35.834321,27.9072746 36.0630864,30.2187464 32.3846914,30.4598534 L21.9328395,31.1450855 C21.9328395,31.1450855 20.7871605,31.2202773 20.674321,30.0794565 L20.5583951,28.9088055 C20.5583951,28.9088055 20.3296296,26.597457 24.0080247,26.3562267 L33.3018519,25.7469261 C33.3018519,25.7469261 35.6055556,25.5959261 35.8325926,27.8897709 L35.834321,27.9072746",
    id: "Fill-4",
    fill: "#DDAB89",
    mask: "url(#hand-illustration-hand_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4111111,33.5870953 C35.4111111,33.5870953 35.6518519,36.0201067 31.78,36.2740333 L20.7792593,36.9951356 C20.7792593,36.9951356 19.5719753,37.0743952 19.4530864,35.8721883 L19.3312346,34.6412605 C19.3312346,34.6412605 19.0904938,32.2081258 22.9623457,31.9543225 L32.7434568,31.3130961 C32.7434568,31.3130961 35.1703704,31.1539606 35.4095062,33.5705777 L35.4111111,33.5870953",
    id: "Fill-5",
    fill: "#DDAB89",
    mask: "url(#hand-illustration-hand_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1428395,41.1162659 C31.1428395,41.1162659 30.9380247,43.2967067 27.4902469,42.8591147 L17.6848148,41.6146277 C17.6848148,41.6146277 16.6192593,41.4794056 16.7195062,40.4116812 L16.8240741,39.2990882 C16.8240741,39.2990882 17.0287654,37.1186475 20.4766667,37.5562394 L29.1920988,38.6622994 C29.1920988,38.6622994 31.3475309,38.9358252 31.1446914,41.0958039 L31.1428395,41.1162659",
    id: "Fill-6",
    fill: "#DDAB89",
    mask: "url(#hand-illustration-hand_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#EDEDED",
    mask: "url(#hand-illustration-hand_mask-2)",
    points: "14.7477778 36.5258644 33.8741975 36.5258644 33.8741975 6.99626992 14.7477778 6.99626992"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-hand_Group-11",
    transform: "translate(16.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hand-illustration-hand_mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hand-illustration-path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-hand_Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "hand-illustration-hand_Fill-9",
    fill: "#FFFFFF",
    mask: "url(#hand-illustration-hand_mask-4)",
    points: "0.00347559384 29.7775214 16.8578714 29.7775214 16.8578714 0.00533119521 0.00347559384 0.00533119521"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-illustration-hand_Group-24",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,33.3781175 L12,35.8733943 C12,35.8733943 12,38.080279 15.6008089,38.080279 L27.2354355,38.080279 C27.2354355,38.080279 30.836366,38.2475291 30.836366,35.0428303 L30.836366,33.3781175 L12,33.3781175 Z M30.8741975,4.00718282 L30.8741975,2.93948639 C30.8741975,2.93948639 30.836366,0.00589829865 27.2354355,0.00589829865 L15.6008089,0.00589829865 C15.6008089,0.00589829865 11.7477778,-0.26927933 11.7477778,2.93948639 L11.7477778,4.00718282 L30.836366,4.0053312 L30.8741975,4.00718282 Z",
    id: "Fill-12",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "hand-illustration-hand_Fill-14",
    fill: "#EDEDED",
    points: "20.0429586 2.26101545 24.2444495 2.26101545 24.2444495 1.72523431 20.0429586 1.72523431"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "hand-illustration-hand_Fill-15",
    fill: "#EDEDED",
    points: "18.8835451 2.26101545 19.5847866 2.26101545 19.5847866 1.72523431 18.8835451 1.72523431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3052437,29.2887839 C20.0742086,27.4568211 18.6899649,31.0916974 16.5754184,32.0422908 C13.1684328,33.5736239 12.1368162,34.6946813 12.1368162,34.6946813 L12.1368162,22.4379599 C11.6050789,22.5897582 9.24222208,23.7411011 8.33188487,25.0776181 C7.42153549,26.4142587 2.72448196,39.5979632 2.44047124,40.4865022 C2.30511108,40.9100046 0.482527604,45.3888513 0,46 L14.6574707,46 C15.828679,44.9845091 17.8297981,42.3815083 18.6425427,38.1599589 C18.6425427,38.1599589 25.9414369,32.2741911 22.3052437,29.2887839 Z",
    id: "Fill-16",
    fill: "#E8BA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3961919,32.434766 C19.3961919,32.434766 17.8164225,31.4882519 18.5440503,30.4956296 C18.5440503,30.4956296 20.1584744,28.0763756 21.5383406,29.3247557 C21.7100335,29.4800151 22.8949821,30.29043 21.9774221,31.6224969 L21.6703934,32.0683734 C21.6703934,32.0683734 20.7528334,33.4004403 19.4425198,32.4676474 L19.3961919,32.434766",
    id: "Fill-17",
    fill: "#EFCFB9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.1191615,19.5413419 L25.8797923,19.4159102 L25.1619946,19.0396503 C25.0611015,18.9867832 24.9368062,18.9867832 24.8359131,19.0396503 L24.1181542,19.4159102 L23.8808385,19.5402867 L23.1630407,19.9164763 C23.0621477,19.9693785 23,20.0670929 23,20.1728621 L23,20.9253117 L23,23 L23.1468064,23 L23.2936128,23 L23.4403805,23 L23.5871869,23 L23.7339933,23 L23.8808385,23 L23.8808385,20.6345606 C23.8808385,20.5287913 23.9429861,20.431077 24.0438792,20.3781748 L24.8359131,19.963012 C24.9368062,19.9101449 25.0611403,19.9101449 25.1620334,19.963012 L25.9561208,20.37923 C26.0570139,20.432097 26.1191615,20.5298817 26.1191615,20.6356158 L26.1191615,23 L26.265968,23 L26.4127744,23 L26.5595808,23 L26.7063872,23 L26.8531936,23 L27,23 L27,20.9263669 L27,20.1739173 C27,20.0681833 26.9378523,19.9704338 26.8369593,19.9175667 L26.1191615,19.5413419 Z",
    id: "Guest",
    fill: "#FFE700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1804637,18.5031111 L25.318599,17.4267801 L24.6507632,17.04069 C24.5568877,16.9864367 24.4412377,16.9864367 24.3473621,17.04069 L23.6794903,17.4267801 L21.8195363,18.5019921 L21.1517006,18.8880822 C21.057825,18.9423355 21,19.0426482 21,19.151191 L21,19.9233712 L21,23 L21.1365593,23 L21.2731547,23 L21.4097501,23 L21.5463455,23 L21.6829409,23 L21.8195363,23 L21.8195363,19.62496 C21.8195363,19.5164172 21.8773613,19.4161406 21.9712368,19.3618512 L24.3473621,17.9882641 C24.4412377,17.9339747 24.5568877,17.9339747 24.6507632,17.9882641 L27.0287632,19.3629341 C27.1226387,19.4172235 27.1804637,19.5175362 27.1804637,19.6260429 L27.1804637,23 L27.3170591,23 L27.4536545,23 L27.5902499,23 L27.7268453,23 L27.8634046,23 L28,23 L28,19.9244181 L28,19.1522739 C28,19.0437672 27.942175,18.9434545 27.8482994,18.8891651 L27.1804637,18.5031111 Z",
    id: "Owner",
    fill: "#FFD00A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8376469,17.9746395 L24.6613307,15.0426965 C24.5608631,14.9857678 24.437092,14.9857678 24.3366245,15.0426965 L19.1623531,17.9735418 C19.0618855,18.0304326 19,18.1355842 19,18.2494038 L19,24.6814035 C19,24.8573375 19.145377,25 19.3247062,25 L23.3855395,25 L23.3855395,24.1394451 L19.8770847,24.1394451 L19.8770847,18.7462432 C19.8770847,18.6324236 19.9389703,18.5272342 20.0394378,18.4703433 L24.3366245,16.0363375 C24.437092,15.9794088 24.5608631,15.9794088 24.6613307,16.0363375 L28.9605236,18.471441 C29.0609911,18.5283697 29.1228767,18.6335213 29.1228767,18.7473409 L29.1228767,24.1394451 L25.6144605,24.1394451 L25.6144605,25 L29.6752938,25 C29.854623,25 30,24.8573375 30,24.6814035 L30,18.2505394 C30,18.1367198 29.9381145,18.0315682 29.8376469,17.9746395",
    id: "Vacasa",
    fill: "#FFAD02"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIllustration);
export default __webpack_public_path__ + "static/media/hand_illustration.84d52c85.svg";
export { ForwardRef as ReactComponent };